import { useRouter } from 'next/router';
import { useEffect } from 'react';

export function useBackButton(callback: any) {
  const router = useRouter();

  useEffect(() => {
    const handleBackButton = () => {
      // Call the provided callback function when the back button is clicked
      callback();
      // router.replace("/eSwarna-digital-gold/gift-gold");
      // Redirect the user to the desired page
      // router.push(desiredPage);
    };

    router.beforePopState(() => {
      handleBackButton();
      return true;
    });
  }, [callback, router]);
}
